import { configureStore } from '@reduxjs/toolkit';

import accessibilityReducer from './slices/accessibility';
import shareTestReducer from './slices/shareTest';
import deleteTestReducer from './slices/deleteTest';
import stopTestReducer from './slices/stopTest';

export let store = null;
export default function createMyStore() {
  if (store) {
    return store;
  }

  const myStore = configureStore({
    reducer: {
      accessibility: accessibilityReducer,
      shareTest: shareTestReducer,
      deleteTest: deleteTestReducer,
      stopTest: stopTestReducer,
    },
  });
  store = myStore;
  return myStore;
}
